'use client';

import Link from 'next/link';
import { useEffect, useRef, useState } from 'react';

type AvatarMenuProps = {
  initials?: string;
};

const MENU_ITEMS = [
  { label: 'My profile', href: '/settings/profile' },
  { label: 'Brand', href: '/settings/brand' },
  { label: 'Organization', href: '/settings/org' },
  { label: 'Billing', href: '/settings/billing' },
  { label: 'Channels', href: '/settings/channels' },
] as const;

export function AvatarMenu({ initials = 'AK' }: AvatarMenuProps) {
  const [open, setOpen] = useState(false);
  const rootRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const handler = (e: MouseEvent) => {
      if (rootRef.current && !rootRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    const escHandler = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setOpen(false);
    };
    window.addEventListener('mousedown', handler);
    window.addEventListener('keydown', escHandler);
    return () => {
      window.removeEventListener('mousedown', handler);
      window.removeEventListener('keydown', escHandler);
    };
  }, [open]);

  return (
    <div ref={rootRef} style={{ position: 'relative', display: 'inline-flex' }}>
      <button
        type="button"
        className={`avatar${open ? ' active' : ''}`}
        aria-label="Account"
        aria-haspopup="menu"
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
      >
        {initials}
      </button>

      {open ? (
        <div className="avatar-menu" role="menu">
          {MENU_ITEMS.map((item) => (
            <Link
              key={item.href}
              href={item.href}
              role="menuitem"
              className="avatar-menu-item"
              onClick={() => setOpen(false)}
            >
              {item.label}
            </Link>
          ))}
          <div className="avatar-menu-divider" />
          <Link href="/auth/sign-out" role="menuitem" className="avatar-menu-item danger">
            Sign out
          </Link>
        </div>
      ) : null}
    </div>
  );
}
